/*  ==========================================================================
    ROOMS DETAIL
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';

// local imports
import * as vars from '../../globals/variables';
import {initDynform} from "../../ehotelier/dynforms/init";
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

// hook function
function funcHook(container,data) {

    // calculate min price and add it to record
    utils.ehotelierPrices.initEhotelierRoomMinPrice(data);

    // get desired room
    let roomDetail,
        roomId = location.pathname.match(/(\d+)\/?$/i)[1];
    $.each(data.records, function(key, record) {
        $.each(record.roomtypes, function(key, roomtype) {
            if(roomtype.id == roomId) {
                roomDetail = roomtype;
            }
        });
    });
    data.roomdetail = roomDetail;

    // replace title-tag in the head area with room title (and add it also to the breadcrumb)
    let roomTitle;
    $.each(data.records, function(key, record) {
        $.each(record.roomtypes, function(key, roomtype) {
            if(roomtype.id == roomId) {
                roomTitle = roomtype.name;
            }
        });
    });
    $('title').html(roomTitle);
    $('#bn-breadcrumb').find('.bn-breadcrumb__divider').last().after('<a class="bn-breadcrumb__item" href="/index.php?id=23&L='+vars.lang_id+'"> '+$('#bn-breadcrumb').find('.bn-breadcrumb__cur').text()+' </a>');
    $('#bn-breadcrumb').find('.bn-breadcrumb__cur').before('<span class="bn-breadcrumb__divider">&nbsp;&gt;&nbsp;</span>');
    $('#bn-breadcrumb').find('.bn-breadcrumb__cur').html(roomTitle);

}

// custom function
function funcCustom(container,data) {

    // magnific popup
    utils.mfp.initGallery(container);
    utils.mfp.initIframe(container);
    utils.mfp.initSingleImage(container);

    // initialize image slider
    let $sliderContainer = $(container).find('.bn-room-box__slider'),
        sliderOverrides = {
            nextArrow: vars.slick_nextArrow,
            prevArrow: vars.slick_prevArrow
        };
    utils.slickCarousel.initSingleSlider($sliderContainer,sliderOverrides);

    // create price list (if container is in view)
    let priceServiceContainer = $(container).find('.eh-rates');
    $(priceServiceContainer).one('inview', function() {
        utils.ehotelierPrices.initEhotelierRoomPriceList(priceServiceContainer);
    });
    if(typeof BN.DynFormsV2 !== 'undefined') {
        initDynform();
    }

    if($(container).find('.bn-button--back').length) {
        $(container).find('.bn-button--back').on('click', function (e) {
            if(document.referrer !== "") {
                e.preventDefault();
                window.history.back();
            }
        });
    }
}

// initialization
export function initRoomDetail($element) {
    let container = $element.find('.eh-service');

    // config
    let config = {
        addParams: {},
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'room',
        subtype: 'detail'
    };

    // ehotelier service initialization
    utils.ehotelierLoader.initEhotlierService(config);

}



// WEBPACK FOOTER //
// ./source/js/modules/lib/room-detail.js